module.exports = __webpack_public_path__ + "img/KS.e8d1a4cf.png";